import React, { useState } from "react";
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Sidebar from "./Sidebar";
// import MainAdmin from "./MainAdmin";
import AddTrack from "./AddTrack";
import TrackList from "./TrackList";
import AllUsers from "./AllUsers";
import Statistics from "./Statistics";
import MyCargo from "./MyCargo";
// import Mailing from "./Mailing";
import Lost from "./Lost";
import PartnerProgramAdmin from "./PartnerProgramAdmin";
import FooterMbl from "./FooterMbl";
import AnnouncementManager from "../AnnouncementManager";

// Новые компоненты для админ функций
import SuperAdminCompanies from "./SuperAdminCompanies";
import SuperAdminUsers from "./SuperAdminUsers";
import CompanySettings from "./CompanySettings";
import CompanyFilials from "./CompanyFilials";
import TrackSearch from "./TrackSearch";

const Dashboard = () => {
  const role = useSelector(state => state.user.currentUser.role);
  
  // Определяем начальный selectedNavItem в зависимости от роли
  const getDefaultNavItem = () => {
    if (role === 'super_admin') return 'statistics';
    if (role === 'company_admin') return 'myCargo';
    if (role === 'filial') return 'addTrack';
    return 'addTrack';
  };

  const [selectedNavItem, setSelectedNavItem] = useState(sessionStorage.getItem('selectedNavItem') || getDefaultNavItem());

  const handleNavItemClick = (navItem) => {
    setSelectedNavItem(navItem);
    sessionStorage.setItem('selectedNavItem', navItem);
  };

    console.log(role)

    // Если пользователь не является администратором (компании или филиала), перенаправляем на /main
    if (role !== 'company_admin' && role !== 'super_admin' && role !== 'filial') {
      return <Navigate to="/main" />;
    }

    localStorage.setItem("role", role)

    return (
      <>
      <div className="footer__menu">
        <FooterMbl onNavItemClick={handleNavItemClick} />
        </div>  
        <div className="dashboard">
          <Sidebar onNavItemClick={handleNavItemClick} />
          {/* {selectedNavItem === "mainAdmin" && <MainAdmin />} */}
          {selectedNavItem === "addTrack" && <AddTrack />}
          {selectedNavItem === "trackList" && <TrackList />}
          {selectedNavItem === "trackSearch" && <TrackSearch />}
          {selectedNavItem === "Lost" && <Lost />}
          {selectedNavItem === "allUsers" && <AllUsers />}
          {(selectedNavItem === "statistics" || selectedNavItem === "superadmin-stats") && <Statistics />}
          {selectedNavItem === "myCargo" && <MyCargo />}
          {selectedNavItem === "mailing" && <PartnerProgramAdmin />}
          {selectedNavItem === "Announcements" && <AnnouncementManager />}

          {/* Новые компоненты для Super Admin */}
          {selectedNavItem === "superadmin-companies" && <SuperAdminCompanies />}
          {selectedNavItem === "superadmin-users" && <SuperAdminUsers />}

          {/* Новые компоненты для Company Admin */}
          {selectedNavItem === "company-settings" && <CompanySettings />}
          {selectedNavItem === "company-filials" && <CompanyFilials />}
          
        </div>
        
      </>

    )
}

export default Dashboard;